/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment, useState, useContext } from 'react'
import calculatePercentage from '../../../../../CommonMethods/percentageCalculator' 
import AcademicRecords from '../..';
import Input from '../../../../../components/InputBox';
import { dataService } from '../../../../../services/data.services';
import GlobalContext from '../../../../../components/Context/GloablContext';
import Pagination from '../../../../../components/Pagination';
import Toast from '../../../../../components/Toast';
import TextSection from '../../../../../components/ToolTip/TextSection';

const Table = ({ studentReportDetails, handleOnClickPageNumber, pageCount, searchParams, handleApplyApi,AY_status }) => {

    const [originalMarks, setOriginalMarks] = useState([])
    const [tempList, setTempList] = useState([])
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [onSubmit, setOnSubmit] = useState(false)
    const [emptyFields, setEmptyFields] = useState(false)
    const [hover, sethover] = useState('')
    const [hoverIndex, sethoverIndex] = useState(null)
    const { setToastmessage, isInactiveBranch } = useContext(GlobalContext)

    /**
    * The function `handleOnMarksEdit` is used to handle the editing of marks in a React component.
    */
    function handleOnMarksEdit(rowIndex) {

        if(AY_status === 'completed')
        {
            setToastErrorMessage('AY Completed. Cannot be edited');
            return;
        }

        setOnSubmit(false)
        setSelectedIndex(rowIndex)
        let newRow = true
        if (originalMarks?.length === 0) {
            setOriginalMarks((prv) => [
                ...prv,
                { ...studentReportDetails[rowIndex]["results"], index: rowIndex }])
            newRow = false
        }
        else {
            Object.entries(originalMarks).forEach(([key, value]) => {
                if (parseInt(value?.index) === rowIndex) {
                    newRow = false
                    return
                }
            })
        }
        if (newRow) {
            setOriginalMarks((prv) => [
                ...prv,
                { ...studentReportDetails[rowIndex]["results"], index: rowIndex }])
        }
        setTempList((prv) => [
            ...prv,
            rowIndex
        ])

    }


    /**
    * The function `handleMarksChange` is used to update the marks values in an array of objects based
    * on the provided `marksId`, `marksValue`, `index`, and `inputIndex`.
    */
    const handleMarksChange = (marksId, marksValue, index, inputIndex) => {
        setToastErrorMessage("")
        setOnSubmit(false)
        setEmptyFields(false)
        setSelectedIndex(index)
        let updateMarks
        Object.entries(originalMarks).forEach(([key, value]) => {
            if (value?.index === index) {
                updateMarks = { value }
            }
        })
        updateMarks = updateMarks?.value

        if (marksId === "max_marks") {
            if (marksValue?.length <= 15) {
                updateMarks[inputIndex]["max_marks"] = parseFloat(marksValue)
            }
        }
        else if (marksId === "secured_marks") {
            if (marksValue?.length <= 15) {
                updateMarks[inputIndex]["secured_marks"] = parseFloat(marksValue)
            }
        }
        setOriginalMarks(originalMarks.map(item => {
            if (item?.index === updateMarks?.index) {
                return { ...item, ...updateMarks }
            }
            return item
        }))

    };


    /**
    * The function `onEditCancel` is used to cancel the editing of an item by removing it from the
    * temporary list, resetting the edit icon state, removing it from the original marks list, and
    * applying the filter.
    */
    function onEditCancel(index) {
        setTempList(tempList.filter((item) =>
            item !== index))
        setOriginalMarks(originalMarks.filter((item) => item.index !== index))
        handleApplyApi()
    }


    /**
     * The function `onEditSubmit` checks if the secured marks for each subject is greater than the
     * maximum marks, and if not, it removes the item from the `tempList` and `originalMarks` arrays
     * and sets the `isEdit` property to false.
     * @returns nothing (undefined) if there is an error.
     */
    const onBlur = (max, secured) => {
        setEmptyFields(false);
    };

    /**
     * The `onEditSubmit` function is used to submit edited marks for a student's academic report,
     * performing validation checks and updating the data accordingly.
     * @returns The function `onEditSubmit` does not explicitly return anything.
     */
    const onEditSubmit = async (index) => {
        setOnSubmit(true)
        setSelectedIndex(index)
        let error = false

        let marksArray = []
        let updateMarks
        Object.entries(originalMarks).forEach(([key, value]) => {
            if (value?.index === index) {
                updateMarks = { value }
            }
        })
        updateMarks = updateMarks?.value
        let subjectArr = Object.entries(updateMarks)?.map(([key, value]) => value)
        subjectArr?.pop()
        marksArray = subjectArr?.map((subject, index) => (
            {
                subject_name: subject?.subject_name,
                secured_marks: subject?.secured_marks,
                max_marks: subject?.max_marks
            }

        ))
        function hasEmptyFields() {
            let isEmpty = false
            marksArray?.map((subject, subindex) => {
                if (subject?.max_marks === "" || subject?.secured_marks === "" || subject?.max_marks === null || subject?.secured_marks === null || isNaN(subject?.max_marks) || isNaN(subject?.secured_marks)) {
                    isEmpty = true
                    return true
                }
            })
            return isEmpty
        }
        function isGreater() {
            let isgreater = false;
            marksArray?.map((subject, subindex) => {
                if (subject?.max_marks < subject?.secured_marks) {
                    isgreater = true
                    return

                }
            })
            return isgreater
        }
        if (isGreater()) {
            setToastErrorMessage("Secured marks cannot exceed max marks")
            return
        }

        if (hasEmptyFields()) {

            setEmptyFields(true)
            setToastErrorMessage("Please enter valid details")
            return
        }
        else {
            try {
                let response = null
                let body = {
                    results: marksArray
                };
                response = await dataService.PatchAPI(body, `academic-reports/${studentReportDetails[index]?._id}`)
                if (!response.error) {
                    setToastmessage("Academic reports updated successfully");
                } else {
                    setToastErrorMessage("Something went wrong")
                }
                handleApplyApi()
                setTempList(tempList.filter((item) =>
                    item !== index))
                setOriginalMarks(originalMarks.filter((item) => item.index !== index))
            } catch (error) {
                setOnSubmit(false)
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            }
        }
    }

    /**
    * The function `handleKeyDown` prevents the character "e" from being entered when the target
    * element is of type "number".
    */
    const handleKeyDown = (event) => {
        if (event.target.type === 'number' && event.key === 'e') {
            event.preventDefault(); // Prevent the "e" character from being entered
        }
    };

    return (
        <div class="w-full">
            <div class="-mx-1">
                <div className={`flex overflow-auto ${studentReportDetails?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1 topHeading`} id = "search-result" >
                    <table aria-label="Outside Table" class="w-full auto-layout" id="admin-table">
                        <thead>
                            <tr>
                                <th class="min-w-[180px]">
                                    <span >
                                        Student ID
                                    </span>
                                </th>
                                <th class="min-w-[250px]">
                                    <span class="flex items-center  justify-start">Student Name
                                    </span>
                                </th>
                                {studentReportDetails[0]?.results?.length > 0 ? (
                                    studentReportDetails[0].results.map((item) => (
                                        <th class="min-w-[412px]" colspan="3" key={item.subject_name}>
                                            <span class="flex items-center justify-center ">{item.subject_name}</span>
                                        </th>
                                    ))
                                ) : (
                                    <th class="min-w-[412px]" colspan="3">
                                        <span class="flex items-center justify-center ">Subject 1</span>
                                    </th>
                                )}
                                <th class=" min-w-[120px]">
                                    <span class="flex items-center justify-center ">Action
                                    </span>
                                </th>
                            </tr>
                            <tr aria-colspan="7" class="h-1">
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-[#FFFFFF] hover:bg-[#EEF7FE]" id="secondHeader">
                                <td class=""></td>
                                <td class="text-start"></td>
                                {studentReportDetails[0]?.results?.length > 0 ? (
                                    studentReportDetails[0].results.map((item) => (
                                        <>
                                            <td class="font-semibold text-end border-l border-[#EDEDED] min-w-[128px]">Max Marks</td>
                                            <td class="font-semibold text-end min-w-[161px]">Secured Marks</td>
                                            <td class="font-semibold text-end">Percentage</td>
                                        </>))
                                ) : (
                                    <>
                                        <td class="font-semibold text-end border-l border-[#EDEDED] min-w-[128px]">Max Marks</td>
                                        <td class="font-semibold text-end min-w-[161px]">Secured Marks</td>
                                        <td class="font-semibold text-end">Percentage</td>
                                    </>
                                )}
                                <td class=" text-start border-l border-[#EDEDED]"></td>

                            </tr>
                            
                            {studentReportDetails?.map((mapItem, index) => (
                                <>
                                    <tr id="student-id" class="group bg-[#FFFFFF] rounded-[16px]" key={mapItem}>
                                        <td class="font-normal   ">
                                            {mapItem.student_id}
                                        </td>
                                        <td class="  font-normal text-start"><span className='more-lines' title={mapItem?.student_name}>{mapItem?.student_name}</span></td>
                                        {mapItem?.results?.map((resultItem, resultIndex) => (
                                            <Fragment key={resultItem}>
                                                <td class="font-normal   border-l border-[#EDEDED] text-end">
                                                    <div>
                                                        <label for=""></label>
                                                        {/* <!-- if the input is editable then add this for input border border-[#D0D5DD]  --> */}
                                                        <input
                                                            id="max_marks"
                                                            type="number"
                                                            min={0}
                                                            autoComplete='off'
                                                            style={{'background-color':'revert'}}
                                                            class={`text-end w-[85px] px-2 outline-0 border ${(index === selectedIndex && emptyFields && isNaN(originalMarks?.find(item => item.index === index)?.[resultIndex]?.["max_marks"])) ? "border-[#F04438]" : "border-[#D0D5DD] "}  ${!tempList.includes(index) ? 'border-none bg-white    ' : ' border-[#D0D5DD] '}  `}
                                                            disabled={(tempList.includes(index)) ? false : true}
                                                            value={tempList.includes(index) ? originalMarks?.find(item => item.index === index)?.[resultIndex]?.["max_marks"] : resultItem?.max_marks}
                                                            onChange={(e) => {
                                                                handleMarksChange(e.target.id,
                                                                    e.target.value, index, resultIndex)

                                                            }}
                                                            step="any"
                                                            pattern="^\d+(?:\.\d{1,2})?$"
                                                            onKeyDown={handleKeyDown}
                                                            onBlur={() => onBlur(originalMarks?.find(item => item.index === index)?.[resultIndex]?.["max_marks"], originalMarks?.find(item => item.index === index)?.[resultIndex]?.["secured_marks"])} />

                                                    </div>
                                                </td>
                                                <td class="  font-normal text-end">
                                                    <div>
                                                        <label for=""></label>
                                                        {/* <!-- if the input is editable then add this for input border border-[#D0D5DD]  --> */}
                                                        <input
                                                            id="secured_marks"
                                                            autoComplete='off'
                                                            min={0}
                                                            type="number"
                                                            style={{'background-color':'revert'}}
                                                            class={`text-end w-[85px] px-2 outline-0 border  ${(index === selectedIndex && emptyFields && (isNaN(originalMarks?.find(item => item.index === index)?.[resultIndex]?.["secured_marks"]) || (originalMarks?.find(item => item.index === index)?.[resultIndex]?.["secured_marks"] === undefined))) || (index === selectedIndex && onSubmit && (originalMarks?.find(item => item.index === index)?.[resultIndex]?.["secured_marks"] > originalMarks?.find(item => item.index === index)?.[resultIndex]?.["max_marks"])) ? 'border-[#F04438]' : 'border-[#D0D5DD]'} ${!tempList.includes(index) ? 'border-none bg-white  ': ''}`}
                                                            disabled={(tempList?.includes(index)) ? false : true}
                                                            value={tempList.includes(index) ? originalMarks?.find(item => item.index === index)?.[resultIndex]?.["secured_marks"] : resultItem?.secured_marks}
                                                            onChange={(e) => {
                                                                handleMarksChange(e.target.id,
                                                                    e.target.value, index, resultIndex)
                                                            }}
                                                            onKeyDown={handleKeyDown}
                                                            step="any"
                                                            pattern="^\d+(?:\.\d{1,2})?$"
                                                            onBlur={() => onBlur(originalMarks?.find(item => item.index === index)?.[resultIndex]?.["max_marks"], originalMarks?.find(item => item.index === index)?.[resultIndex]?.["secured_marks"])} />
                                                    </div>
                                                </td>
                                                <td class="  text-end">
                                                    <span>
                                                        {isNaN(calculatePercentage(resultItem.secured_marks, resultItem.max_marks)) ||
                                                            !isFinite(calculatePercentage(resultItem.secured_marks, resultItem.max_marks))
                                                            ? '0%'
                                                            : `${calculatePercentage(resultItem.secured_marks, resultItem.max_marks)}%`}
                                                    </span>
                                                </td>
                                            </Fragment>))}
                                        <td className="   text-center border-l border-[#EDEDED]">
                                            {!tempList.includes(index) &&
                                                <>
                                                    <>{hover === 'modify' && (hoverIndex === index) &&
                                                        <div className='relative top-[45px] -left-10'>
                                                            <TextSection text='Modify Marks' show from={'academicreports'} />
                                                        </div>}
                                                    </>
                                                    <button 
                                                        type="button" 
                                                        className={`edit_value ${isInactiveBranch?"img-disable":""}`}
                                                        disabled={isInactiveBranch}
                                                        id = {index + "action"} 
                                                        onMouseEnter={()=>{sethover('modify'), 
                                                        sethoverIndex(index)}} 
                                                        onMouseLeave={()=>{sethover(''), sethoverIndex(null)}} 
                                                        onClick={()=>handleOnMarksEdit(index)}>
                                                        <img loading="lazy" decoding="async" src="/images/offcanvasEditDetails.svg" alt="img"/>
                                                    </button>
                                                </>
                                            }
                                            {tempList.includes(index) && <div class="edit_table_value flex items-center relative ml-[25px]">
                                                <div className='relative'>
                                                    <>{hover === 'update' && (hoverIndex === index) &&
                                                        <div className='absolute top-[45px] -left-5'>
                                                            <TextSection text='Update' show from={'academicreports'} />
                                                        </div>}
                                                    </>
                                                    <button id = {index + "update"} onMouseEnter={() => { sethover('update'), sethoverIndex(index) }} onMouseLeave={() => { sethover(''), sethoverIndex(null) }} type="button" class="px-[3px] relative" onClick={() => onEditSubmit(index)}>
                                                        <img loading="lazy" decoding="async"src="/images/otp-tick.svg" alt="img" class="w-5 h-5" />
                                                    </button>
                                                </div>
                                                <div className='relative'>
                                                    <>{hover === 'Cancel' && (hoverIndex === index) &&
                                                        <div className='absolute top-[45px] -left-4'>
                                                            <TextSection text='Cancel' show from={'academicreports'} />
                                                        </div>}
                                                    </>
                                                    <button type="button" onMouseEnter={()=>{sethover('Cancel'), sethoverIndex(index)}} onMouseLeave={()=>{sethover(''), sethoverIndex(null)}} class="px-[3px] ml-1 relative" onClick={()=>onEditCancel(index)}>
                                                        <img loading="lazy" decoding="async" src="/images/file-remove.svg" alt="img" class="w-5 h-5"/>
                                                    </button>
                                                </div>
                                            </div>}

                                        </td>
                                    </tr>
                                    
                                </>
                            ))}
                        </tbody>
                        {studentReportDetails?.length === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px'}} colspan="14" className="no-records-message" id='no-matching-result'>
                                        {searchParams.get("academic_year") == null ? `Select 'Academic Year', 'Class', 'Section' and 'Exam' to view Academic Reports` : AY_status==="completed" ? `No academic reports uploaded. AY is completed`: `No academic reports uploaded yet. Click the three dots button to download the sample file or upload your report`}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
                {(pageCount.total_count > 10) && <Pagination
                    TotalCount={pageCount.total_count}
                    totalPageNumber={Math.ceil(pageCount.total_count / 10)}
                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div>
            {toastErrorMessage !== '' &&
                <Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage}
                />
            }
        </div>

    )
}

export default Table